import React from "react";
import { useState, useEffect } from "react";
function NavigateURL() {
  useEffect(() => {
    RedirectMe();
  }, []);

  function RedirectMe() {
   // window.location = "https://www.jlrmenabusinesstools.com/SSO.aspx?GetMeLogIn=https://repscorecardapp.jlrmenabusinesstools.com/verifycr?a=1" as any;
  }

  return <div></div>;
}

export default NavigateURL;
